var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// react
import React, { useEffect, useState } from 'react';
import { withStyles, Grid } from '@material-ui/core';
import { dAxios, snackBarRsp } from 'consts';
import { HOST } from 'config';
import styled from 'styled-components';
import { useSnackbar } from 'notistack';
import { MasterGrids2 } from 'component/LHH/MasterGrids/MasterGrids';
import Alert from '@material-ui/lab/Alert';
import { ButtonContain } from 'component/material/ButtonContained/Button';
import { ButtonBar } from 'component/material/ButtonContained/ButtonBar';
import Radio from 'component/material/Radio';
import { Title } from 'component/title/Title';
import { setLoadingRedux } from 'reducers/sharedata/action';
import { useDispatch } from 'react-redux';
import InputCellPhone from 'component/material/Input/InputCellPhone';
import InputEngNum from 'component/material/Input/InputEngNum';
import InputPin from 'component/material/Input/InputPin';
import Input from 'component/material/Input';
import { PageTypeEnum } from 'reducers/sharedata/types';
import { getToken } from 'main_api';
import { inputChange, inputVal, radioChange } from 'component/consts';
// eslint-disable-next-line @typescript-eslint/no-var-requires
var mainStyle = require('main_style.module.css');
// styled ---------------------------------------------
var StyleRoot = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* position: absolute;\n  top: 10%;\n  left: 50%;\n  transform: translateX(-50%); */\n  font-size: 1.2em;\n  min-width: 300px;\n  width: 40%;\n  padding: 0 20px;\n  .MuiStepper-root {\n    background-color: rgb(247, 247, 247);\n  }\n"], ["\n  /* position: absolute;\n  top: 10%;\n  left: 50%;\n  transform: translateX(-50%); */\n  font-size: 1.2em;\n  min-width: 300px;\n  width: 40%;\n  padding: 0 20px;\n  .MuiStepper-root {\n    background-color: rgb(247, 247, 247);\n  }\n"])));
var StyleDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  .MuiGrid-item {\n    font-size: 1.2rem;\n  }\n"], ["\n  .MuiGrid-item {\n    font-size: 1.2rem;\n  }\n"])));
var StyleAlert = withStyles({
    root: {
        fontSize: '1.8rem',
        marginBottom: '5px',
        display: 'flex',
        justifyContent: 'center',
    },
    icon: {
        fontSize: '1.5em',
    },
})(Alert);
// component ---------------------------------------------
var ResetPassword = function (props) {
    var dispatch = useDispatch();
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var _a = useState(PageTypeEnum.home), pageShow = _a[0], setPageShow = _a[1];
    var _b = useState(false), verifyError = _b[0], setVerifyError = _b[1];
    var _c = useState(false), verifyError2 = _c[0], setVerifyError2 = _c[1];
    var _d = useState(true), beforeSMS = _d[0], setBeforeSMS = _d[1];
    var _e = useState({
        lang: 'TW',
        type: 'W',
        manual: 'Y',
        userId: '',
        telNo: '',
        email: '',
    }), storeData = _e[0], setStoreData = _e[1];
    var _f = useState({
        lang: 'TW',
        userId: '',
        vercodeTransactionId: '',
        verCode: '',
        newPwd: '',
    }), storeData2 = _f[0], setStoreData2 = _f[1];
    var UpdateData = function (updateObj) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setStoreData(function (prev) { return (__assign(__assign({}, prev), updateObj)); });
            return [2 /*return*/];
        });
    }); };
    var UpdateData2 = function (updateObj) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setStoreData2(function (prev) { return (__assign(__assign({}, prev), updateObj)); });
            return [2 /*return*/];
        });
    }); };
    var submitCheck = function () {
        setVerifyError(true);
        if (!storeData.userId ||
            (storeData.manual === 'Y' && !storeData.email) ||
            (storeData.manual === 'N' && !storeData.telNo)) {
            return false;
        }
        return true;
    };
    var handleSMS = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var submitData, response, _a, userId, vercodeTransactionId;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (e && e.preventDefault) {
                        e.preventDefault();
                    }
                    if (!submitCheck()) {
                        return [2 /*return*/];
                    }
                    submitData = __assign({}, storeData);
                    if (storeData.manual === 'Y')
                        delete submitData.telNo;
                    else if (storeData.manual === 'N')
                        delete submitData.email;
                    dispatch(setLoadingRedux(1));
                    return [4 /*yield*/, dAxios('post', HOST + "v1/user/secret/ver-code", submitData, enqueueSnackbar)];
                case 1:
                    response = _b.sent();
                    dispatch(setLoadingRedux(-1));
                    if (!snackBarRsp(enqueueSnackbar, response)) {
                        return [2 /*return*/];
                    }
                    if (!response) {
                        return [2 /*return*/];
                    }
                    _a = response.data.data, userId = _a.userId, vercodeTransactionId = _a.vercodeTransactionId;
                    setStoreData2(function (prev) { return (__assign(__assign({}, prev), { userId: userId, vercodeTransactionId: vercodeTransactionId })); });
                    setBeforeSMS(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var submitCheck2 = function () {
        setVerifyError2(true);
        if (storeData2.verCode.length !== 6 || !storeData2.newPwd) {
            return false;
        }
        return true;
    };
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (e && e.preventDefault) {
                        e.preventDefault();
                    }
                    if (!submitCheck2()) {
                        return [2 /*return*/];
                    }
                    dispatch(setLoadingRedux(1));
                    return [4 /*yield*/, dAxios('post', HOST + "v2/user/secret/reset", storeData2, enqueueSnackbar)];
                case 1:
                    response = _c.sent();
                    dispatch(setLoadingRedux(-1));
                    if (!snackBarRsp(enqueueSnackbar, response)) {
                        return [2 /*return*/];
                    }
                    if (((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.status) === 'Y') {
                        setPageShow(PageTypeEnum.detail); // 進入成功畫面
                    }
                    else {
                        enqueueSnackbar(((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.msg) || '密碼修改失敗，請稍後再試', {
                            variant: 'error',
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getToken(enqueueSnackbar);
    }, []);
    var QueryConds = [
        {
            t: '*身分證號碼',
            child: (React.createElement(InputPin, { className: mainStyle.input, required: true, disabled: !beforeSMS, verifyBeforeChange: verifyError, placeholder: "\u8ACB\u8F38\u5165\u8EAB\u5206\u8B49\u865F\u78BC", value: storeData.userId || '', name: "userId", onChange: inputChange(UpdateData) })),
        },
        {
            t: '*驗證發送方式',
            child: (React.createElement(React.Fragment, null,
                React.createElement("div", { style: { display: 'flex' } },
                    React.createElement(Radio, { required: true, disabled: !beforeSMS, verifyBeforeChange: verifyError, name: "manual", value: inputVal(storeData.manual), onChange: radioChange(UpdateData), options: [
                            { value: 'Y', label: 'Email 傳送' },
                            { value: 'N', label: '簡訊傳送' },
                        ] })),
                storeData.manual === 'Y' ? (React.createElement("div", { style: { marginTop: 5 } },
                    React.createElement(Input, { className: mainStyle.input, type: "email", required: true, disabled: !beforeSMS, verifyBeforeChange: verifyError, placeholder: "\u8ACB\u8F38\u5165 Email", inputProps: { maxLength: 50 }, value: storeData.email || '', name: "email", onChange: function (e) {
                            e.target.value = e.target.value.toUpperCase(); // 轉為大寫
                            inputChange(UpdateData)(e);
                        } }))) : (React.createElement("div", { style: { marginTop: 5 } },
                    React.createElement(InputCellPhone, { className: mainStyle.input, required: true, disabled: !beforeSMS, verifyBeforeChange: verifyError, placeholder: "\u8ACB\u8F38\u5165\u5E33\u865F\u64C1\u6709\u8005\u7684\u624B\u6A5F\u865F\u78BC", value: storeData.telNo || '', name: "telNo", onChange: inputChange(UpdateData) }))))),
        },
        {
            t: '*驗證碼',
            show: !beforeSMS,
            child: (React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, sm: true },
                    React.createElement(Input, { className: mainStyle.input, required: true, verifyBeforeChange: verifyError2, inputProps: { minLength: 6, maxLength: 6 }, placeholder: "\u8ACB\u8F38\u5165 6 \u4F4D\u9A57\u8B49\u78BC", value: storeData2.verCode || '', name: "verCode", onChange: inputChange(UpdateData2) })),
                React.createElement(Grid, { item: true, sm: true, className: mainStyle.flexVerticalCenter },
                    React.createElement("span", { style: { marginLeft: 5 } }, " \u9A57\u8B49\u78BC\u6700\u591A\u91CD\u767C\u4E8C\u6B21 ")))),
        },
        {
            t: '*設定密碼',
            show: !beforeSMS,
            child: (React.createElement(InputEngNum, { className: mainStyle.input, type: "password", required: true, verifyBeforeChange: verifyError2, inputProps: { minLength: 5, maxLength: 30 }, placeholder: "\u8ACB\u8F38\u5165\u5BC6\u78BC", value: storeData2.newPwd || '', name: "newPwd", onChange: inputChange(UpdateData2) })),
        },
    ];
    return (React.createElement("div", { style: {
            backgroundColor: 'rgb(247, 247, 247)',
            height: '100vh',
            minHeight: 500,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        } },
        React.createElement(StyleRoot, null,
            React.createElement("div", { style: { display: pageShow === PageTypeEnum.home ? 'block' : 'none' } },
                React.createElement(Title, { title: "\u5FD8\u8A18\u5BC6\u78BC" }),
                React.createElement("div", { style: { color: '#545454' } }, "\u63D0\u9192\uFF1A\u6309\u4E0B\u300C\u9001\u51FA\u300D\u6309\u7D10\u5F8C\uFF0C\u7CFB\u7D71\u5C07\u6703\u5BC4\u51FA\u300C\u5BC6\u78BC\u9A57\u8B49\u78BC\u901A\u77E5\u300D\uFF0C\u8ACB\u52D9\u5FC5\u5230\u6240\u586B\u4FE1\u7BB1\u6216\u624B\u6A5F\u865F\u78BC\u6536\u4FE1\u53CA\u91CD\u8A2D\u5BC6\u78BC\uFF01"),
                React.createElement("form", { onInvalid: function () { return setVerifyError(true); }, onSubmit: handleSMS },
                    React.createElement(StyleDiv, null,
                        React.createElement(MasterGrids2, { mGrids: QueryConds, md: [3, 9] })),
                    React.createElement(ButtonBar, null,
                        React.createElement(ButtonContain, { variant: "outlined", onClick: function () { return props.history.goBack(); } }, "\u53D6\u6D88"),
                        beforeSMS && (React.createElement(ButtonContain, { type: "submit", disabled: !beforeSMS }, "\u767C\u9001")),
                        !beforeSMS && (React.createElement(ButtonContain, { onClick: handleSubmit }, "\u78BA\u5B9A"))))),
            pageShow === PageTypeEnum.detail && (React.createElement(React.Fragment, null,
                React.createElement(StyleAlert, { variant: "filled", severity: "success" }, "\u4FEE\u6539\u6210\u529F\uFF0C\u8ACB\u91CD\u65B0\u767B\u5165\uFF01"),
                React.createElement(ButtonBar, null,
                    React.createElement(ButtonContain, { onClick: function () { return props.history.goBack(); } }, "\u56DE\u9996\u9801")))))));
};
export default ResetPassword;
var templateObject_1, templateObject_2;
